import {connect} from 'react-redux';
import FireStationDetails from 'app/components/RightBarPane/Property/FireStationDetails';

export const mapStateToProps = (state) => ({
    emapLabel: state.getIn(['property', 'selectedProperty', 'qbeData', 'emapLabel']),
});

export default connect(mapStateToProps)(FireStationDetails);